






















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import TargetMixin from "@/mixins/http/Grp/Target";

@Component
export default class CompetitorsFooter extends Mixins(TargetMixin) {
  @Prop({ default: false }) readonly showGrp!: string;
  @Prop() readonly grpTargetId!: string | number;

  @Watch("showGrp")
  onShowGrpChanged() {
    this.loadData();
  }

  @Watch("grpTargetId")
  onTargetIdChanged() {
    this.loadData();
  }

  loading = false;
  population = "";

  async mounted() {
    this.loadData();
  }

  async loadData() {
    if (!this.showGrp) {
      return;
    }

    const dateStart = this.$route.query.date;
    const weekly = this.$route.query.weeklyData == "true";
    const dateEnd = weekly
      ? this.$moment(dateStart).subtract(6, "days").format("YYYY-MM-DD")
      : dateStart;

    this.loading = true;
    const pop = await this.getTargetPopulation({
      id: this.grpTargetId,
      start: dateEnd,
      end: dateStart,
    });
    this.population = pop.meta.population;
    this.loading = false;
  }
}
